<p class="desc">{{day.day}}</p>
<span class="desc anniversaries">
  <p class="anniversary"
    *ngFor="let anniv of day.anniversaries"
    [ngClass]="anniv.type">{{anniv.name}}</p>
</span>
